import { FormControlLabel, styled } from '@mui/material';
import { omitForwardedProps } from 'common/utils';

export type StyledFormControlLabelProps = {
  variant?: 'default' | 'outlined';
  labelAlign?: 'top' | 'middle';
};

export const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: omitForwardedProps<StyledFormControlLabelProps>('variant', 'labelAlign'),
})<StyledFormControlLabelProps>(
  ({ theme: { palette, shape, spacing, typography }, variant, labelAlign = 'middle', checked }) => ({
    margin: 0,
    gap: spacing(1),

    '& > .MuiFormControlLabel-label': {
      ...typography['natter-text-sm'],
    },

    '&.MuiFormControlLabel-labelPlacementEnd > .MuiFormControlLabel-label': {
      paddingRight: spacing(1),
    },

    '&.MuiFormControlLabel-labelPlacementStart > .MuiFormControlLabel-label': {
      paddingLeft: spacing(1),
    },

    ...(labelAlign === 'top' && {
      alignItems: 'flex-start',
      '& > div': {
        marginTop: spacing(1),
      },
    }),

    ...(variant === 'outlined' && {
      padding: spacing(1),
      fontWeight: 500,

      borderRadius: shape.borderRadius,
      border: '1px solid',
      borderColor: palette.divider,

      ...(checked && {
        backgroundColor: palette.extendedPrimary[25],
        borderColor: palette.primary.main,
      }),
    }),
  })
);
